import { render, staticRenderFns } from "./wang.vue?vue&type=template&id=08b55de4&scoped=true&"
import script from "./wang.vue?vue&type=script&lang=js&"
export * from "./wang.vue?vue&type=script&lang=js&"
import style0 from "./wang.vue?vue&type=style&index=0&id=08b55de4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b55de4",
  null
  
)

export default component.exports